import { observable, action, computed, configure, runInAction } from 'mobx';
import { createContext} from 'react';
import { ITechnicianCertificate } from '../models/techniciancertificate';
import { ITechnicianCertificateName } from '../models/techniciancertificatename';
import { ITechnicianCertificatePhoto } from '../models/techniciancertificatephoto';
import { ITechnician } from '../models/technician';
import { ICertificate } from '../models/certificate';
import { toast } from 'react-toastify';
import agent from '../api/agent';

configure({enforceActions: 'always'});

class TechnicianCertificateStore {
  @observable techniciancertificateRegistry = new Map();
  @observable techniciancertificate: ITechnicianCertificate | null = null;
  @observable techniciancertificatenameRegistry = new Map();
  @observable techniciancertificatename: ITechnicianCertificateName | null = null;
  @observable techniciancertificatephotoRegistry = new Map();
  @observable techniciancertificatephoto: ITechnicianCertificatePhoto | null = null;
  @observable technicianRegistry = new Map();
  @observable technician: ITechnician | null = null;
  @observable certificateRegistry = new Map();
  @observable certificateSearchRegistry = new Map();
  @observable certificate: ICertificate | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = '';

  @computed get techniciancertificatenamesByEmail() {
    return Array.from(this.techniciancertificatenameRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }
  
  @computed get techniciansByName() {
    return Array.from(this.technicianRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get certificatesByName() {
    return Array.from(this.certificateRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get certificatesSearch() {
    return Array.from(this.certificateSearchRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get techniciancertificatephotosById() {
    return Array.from(this.techniciancertificatephotoRegistry.values())
    ;
  }

  @action loadTechnicianCertificates = async () => {
    this.loadingInitial = true;
    try {
      const techniciancertificates = await agent.TechnicianCertificates.list();
      runInAction('loading techniciancertificates', () => {
        techniciancertificates.forEach(techniciancertificate => {
          this.techniciancertificateRegistry.set(techniciancertificate.id, techniciancertificate);
        });
        this.loadingInitial = false;
      })

    } catch (error) {
      runInAction('load TechnicianCertificate List error', () => {
        this.loadingInitial = false;
      })
      toast.error('load TechnicianCertificate List error');
    }
  };

  @action searchTechnicianCertificates = async (search : {technicianemail: string, certone: string, certtwo: string, certthree: string, expiry: string}) => {
    const params = new URLSearchParams();
    params.append('technicianemail', search.technicianemail);
    params.append('certone', search.certone);
    params.append('certtwo', search.certtwo);
    params.append('certthree', search.certthree);
    params.append('expiry', search.expiry);

    this.loadingInitial = true;
    try {
      const techniciancertificatenames = await agent.TechnicianCertificates.search(params);
      this.techniciancertificatenameRegistry.clear();
      runInAction('loading techniciancertificates', () => {
        techniciancertificatenames.forEach(techniciancertificatename => {
          if (techniciancertificatename.expiryDate !== null)  
          techniciancertificatename.expiryDate = techniciancertificatename.expiryDate.substr(0,10)
          this.techniciancertificatenameRegistry.set(techniciancertificatename.id, techniciancertificatename);
        });
        this.loadingInitial = false;
      })

    } catch (error) {
      runInAction('load TechnicianCertificate List error', () => {
        this.loadingInitial = false;
      })
      toast.error('load TechnicianCertificate List error');
    }
  };

  @action loadTechnicianCertificate = async (id: string) => {
    let techniciancertificatename = this.getTechnicianCertificate(id);
    if (techniciancertificatename) {
      this.techniciancertificatename = techniciancertificatename;
      return techniciancertificatename;
    } else {
      this.loadingInitial = true;
      try {
        const techniciancertificatename = await agent.TechnicianCertificates.details(id);
        runInAction('getting techniciancertificate',() => {
          this.techniciancertificatenameRegistry.clear();
          this.techniciancertificatename = techniciancertificatename;
          if (techniciancertificatename.expiryDate !== null)  techniciancertificatename.expiryDate = techniciancertificatename.expiryDate.substr(0,10);
          this.techniciancertificatenameRegistry.set(techniciancertificatename.id, techniciancertificatename);
          this.loadingInitial = false;
        })
        return techniciancertificatename;
      } catch (error) {
        runInAction('get techniciancertificate error', () => {
          this.loadingInitial = false;
        })
        toast.error('get techniciancertificate error');
        console.log(error);
      }
    }
  }

  @action clearTechnicianCertificate = () => {
    this.techniciancertificate = null;
  }

  @action clearTechnicianCertificates = () => {
    this.techniciancertificatenameRegistry.clear();
    this.techniciancertificateRegistry.clear();
    this.techniciancertificatephotoRegistry.clear();
  }

  getTechnicianCertificate = (id: string) => {
    return this.techniciancertificatenameRegistry.get(Number(id));
  }

  // @action createTechnicianCertificate = async (techniciancertificate: ITechnicianCertificate) => {
  //   this.submitting = true;
  //   try {
  //     techniciancertificate.createdAt = new Date().toJSON();
  //     techniciancertificate.updatedAt = new Date().toJSON();
  //     const techniciancertificatename = await agent.TechnicianCertificates.create(techniciancertificate);
  //     runInAction('create Techncian', () => {
  //       this.techniciancertificatenameRegistry.clear();
  //         this.techniciancertificatename = techniciancertificatename;
  //         if (techniciancertificatename.expiryDate !== null)  techniciancertificatename.expiryDate = techniciancertificatename.expiryDate.substr(0,10);
  //         this.techniciancertificatenameRegistry.set(techniciancertificatename.id, techniciancertificatename);
  //       this.submitting = false;
  //     })
  //   } catch (error) {
  //     runInAction('create TechnicianCertificate error', () => {
  //       this.submitting = false;
  //     })
  //     toast.error('create TechnicianCertificate error');
  //     console.log(error);
  //   }
  // };

  @action createTechnicianCertificate = async (techniciancertificate: ITechnicianCertificate[]) => {
    this.submitting = true;
    try {
      await agent.TechnicianCertificates.create(techniciancertificate);
      runInAction('create Techncian', () => {
        
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create TechnicianCertificate error', () => {
        this.submitting = false;
      })
      toast.error('create TechnicianCertificate error');
      console.log(error);
    }
  };

  @action editTechnicianCertificate = async (techniciancertificate: ITechnicianCertificate) => {
    this.submitting = true;
    try {
      await agent.TechnicianCertificates.update(techniciancertificate);
      runInAction('editing techniciancertificate', () => {
        this.techniciancertificateRegistry.set(techniciancertificate.id, techniciancertificate);
        let techniciancertificatename = this.techniciancertificatenameRegistry.get(techniciancertificate.id);
        techniciancertificatename.certificateId = techniciancertificate.certificateId;
        techniciancertificatename.technicianEmail = techniciancertificate.technicianEmail;
        techniciancertificatename.expiryDate = techniciancertificate.expiryDate;
        techniciancertificatename.verified = techniciancertificate.verified;
        techniciancertificatename.remark = techniciancertificate.remark;
        this.techniciancertificatenameRegistry.set(techniciancertificatename.id, techniciancertificatename);
        this.techniciancertificate = techniciancertificate;
        this.submitting = false;
      })
    } catch (error) {
      runInAction('edit techniciancertificate error', () => {
        this.submitting = false;
      })
      toast.error('edit techniciancertificate error');
      console.log(error);
    }
  };

  @action deleteTechnicianCertificate = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.TechnicianCertificates.delete(id);
      runInAction('deleting TechnicianCertificate', () => {
        this.techniciancertificatenameRegistry.delete(id);
        this.submitting = false;
        this.target = '';
      })
    } catch (error) {
      runInAction('delete TechnicianCertificate error', () => {
        this.submitting = false;
        this.target = '';
      })
      toast.error('delete TechnicianCertificate error');
      console.log(error);
    }
  }

  @action loadTechnicians = async () => {
    this.loadingInitial = true;
    try {
      const technicians = await agent.Employees.list();
      this.technicianRegistry.clear();
      runInAction('loading technicians', () => {
        technicians.forEach(technician => {
          if (technician.status !== "Resigned")  this.technicianRegistry.set(technician.email, technician);
        });
        this.loadingInitial = false;
      })
  
    } catch (error) {
      runInAction('load Technician List error', () => {
        this.loadingInitial = false;
      })
      toast.error('load Technician List error');
    }
  };



@action loadCertificates = async () => {
  this.loadingInitial = true;
  try {
    const certificates = await agent.Certificates.list();
    runInAction('loading certificates', () => {
      certificates.forEach(certificate => {
        this.certificateRegistry.set(certificate.id, certificate);
        this.certificateSearchRegistry.set(certificate.id, certificate);
      });
      this.loadingInitial = false;
    })

  } catch (error) {
    runInAction('load Certificate List error', () => {
      this.loadingInitial = false;
    })
    toast.error('load Certificate List error');
  }
};

@action loadTechnicianCertificatePhoto = async (email: string, certificateId: string) => {
    this.loadingInitial = true;
    try {
      const techniciancertificatephotos = await agent.TechnicianCertificatePhotos.list(email, certificateId);
      runInAction('loading techniciancertificate photos', () => {
        this.techniciancertificatephotoRegistry.clear();
        techniciancertificatephotos.forEach(techniciancertificatephoto => {
          this.techniciancertificatephotoRegistry.set(techniciancertificatephoto.id, techniciancertificatephoto);
        });
        this.loadingInitial = false;
      })
    } catch (error) {
      runInAction('get techniciancertificate photo error', () => {
        this.loadingInitial = false;
      })
      toast.error('get techniciancertificate photo error');
      console.log(error);
    }
  
}

@action deleteTechnicianCertificatePhoto = async (id: string) => {
  this.submitting = true;
  this.target = id;
  try {
    await agent.TechnicianCertificatePhotos.delete(id);
    runInAction('deleting TechnicianCertificate photo', () => {
      this.techniciancertificatephotoRegistry.delete(id);
      this.submitting = false;
      this.target = '';
      toast.success('Certificate photo deleted');
    })
  } catch (error) {
    runInAction('delete TechnicianCertificate photo error', () => {
      this.submitting = false;
      this.target = '';
    })
    toast.error('delete TechnicianCertificate photo error');
    console.log(error);
  }
}

@action loadTechnicianCertificateZipFile = async (email: string) => {
  if (email === '')
  {
    toast.warning('please select technician');
    return '';
  }
  this.loadingInitial = true;
  try {
    const zipFile = await agent.TechnicianCertificatePhotos.batch(email);
    runInAction('loading techniciancertificate photos', () => {
      this.loadingInitial = false;
    })
    return zipFile.url;
  } catch (error) {
    runInAction('download techniciancertificate photo error', () => {
      this.loadingInitial = false;
    })
    toast.error('download techniciancertificate photo error');
    console.log(error);
  }
}

@action verifyTechnicianCertificate = async (id: string) => {
  try {
    await agent.TechnicianCertificates.verify(id);
    runInAction('verifying TechnicianCertificate', () => {
      let techniciancertificatename = this.getTechnicianCertificate(id);
      techniciancertificatename.verified = "Y";
      this.techniciancertificatenameRegistry.set(id, techniciancertificatename);
    })
  } catch (error) {
    toast.error('verify TechnicianCertificate error');
    console.log(error);
  }
}

@action searchCertificate = async (term: string) => {
  let certificates = Array.from(this.certificateRegistry.values());
  if (term) {
    const selectedCertificates = certificates.filter((certificate) =>
      certificate.name.toLowerCase().includes(term.toLowerCase()) 
    );
    this.certificateSearchRegistry.clear();
      selectedCertificates.forEach((certificate) => {
        this.certificateSearchRegistry.set(certificate.id, certificate);
      });
  } else {
    this.certificateSearchRegistry.clear();
    certificates.forEach((certificate) => {
      this.certificateSearchRegistry.set(certificate.id, certificate);
    });
  }
};

}

export default createContext(new TechnicianCertificateStore());
